// Zakładka Osiągnięcia - tylko przy koncie z urządzeniem linii z osiągnięciami (lista linii z opisu w Go, jak stara
// APP: pozycja ukryta bez urządzeń ze statystykami). Ten sam warunek dla pozycji menu i ekranu.
import { useSklad } from "../../brama/uzyj";
import { OSIAGNIECIA_LINII } from "../../gen/kontrakt";

export function useZOsiagnieciami(): boolean {
  return useSklad().some((d) => d.typ in OSIAGNIECIA_LINII);
}
